mutation SetGoogleMeetIsEnabled($input: SetGoogleMeetIsEnabledInput!) {
    setGoogleMeetIsEnabled(input: $input) {
        authUrl
        googleMeetIntegration {
            isEnabledCalendarSync
            isEnabledMeetSync
        }
    }
}
